export enum TipoPersona{
    Juridica,
    Fisica,
    Otro
}